export default {root:'m-18320242','skeleton-fade':'m-299c329c'};